// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"styles_skeletonContainer__6Nlep","skeletonContainer__card":"styles_skeletonContainer__card__JOcu8"};